<section class="basic-profile-content-wrapper">
  <div class="basic-profile-header k-d-flex k-justify-content-between k-align-items-flex-start k-gap-4">
    <div class="k-d-flex k-flex-column k-flex-1">
      <h3 class="profile-title">Basic profile</h3>
      <p class="profile-desc body-md">Update your company photo and details here.</p>
    </div>
    @if (!isEditing) {
    <button kendoButton themeColor="primary" size="small" (click)="toggleEditMode()">
      <span class="btn-icon" data-icon-position="left">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M4.41214 13.0157L13.0171 4.41074C13.3421 4.08574 13.8696 4.08574 14.1946 4.41074L15.5913 5.80741C15.9163 6.13241 15.9163 6.65991 15.5913 6.98491L6.98547 15.5891C6.82964 15.7457 6.61797 15.8332 6.39714 15.8332H4.16797V13.6041C4.16797 13.3832 4.25547 13.1716 4.41214 13.0157Z"
            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M11.457 5.9668L14.032 8.5418" stroke="white" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </span>
      Edit
    </button>
    }
  </div>

  <div class="basic-profile-content-container k-mt-6">

    @if (!isEditing) {
    <app-basic-profile-view></app-basic-profile-view>
    }
    @defer (when isEditing) {
    @if (isEditing) {
    <app-basic-profile-edit></app-basic-profile-edit>
    }
    }
  </div>
</section>
